import 'vuetify/dist/vuetify.min.css'
import 'font-awesome/css/font-awesome.css'
// import '@fullcalendar/core/main.css'
// import '@fullcalendar/daygrid/main.css'

import Vue from 'vue'
import { runtimeEnv } from '@/utils/runtimeEnv'
import Vuetify from 'vuetify'
import VueMeta from 'vue-meta'
import VueMoment from 'vue-moment'
import VeeValidate from 'vee-validate'
import VueRouter from 'vue-router'
import * as VueGoogleMaps from 'vue2-google-maps'
import $ from 'jquery'

import Schedule from '../components/inspection/Schedule'
import store from '../store/schedule'

Vue.use(Vuetify, {
  theme: {
    primary: '#3577A8',
    secondary: '#2B6088',
    error: '#dc1414',
    info: '#008535',
    success: '#008535',
    warning: '#dc1414',
    accent: '#3577A8',
    orange: '#dc6514',
  },
})
Vue.use(VeeValidate)
Vue.use(VueMeta)
Vue.use(VueMoment)
Vue.use(VueRouter)
Vue.use(VueGoogleMaps, {
  load: {
    key: runtimeEnv('GOOGLE_MAPS_API_KEY'),
    libraries: 'places',
  },
})

const routes = [
  {
    name: 'schedule',
    path: '/home-inspectors/:companySlug/schedule',
    component: Schedule,
  },
  {
    name: 'scheduleStep',
    path: '/home-inspectors/:companySlug/schedule/:step',
    component: Schedule,
  },
]

const router = new VueRouter({ mode: 'history', routes: routes })

document.addEventListener('DOMContentLoaded', () => {
  const el = document.body.appendChild(
    document.createElement('schedule-inspection')
  )
  // eslint-disable-next-line no-unused-vars
  const app = new Vue({
    el,
    store,
    router,
    render: (h) => h(Schedule),
  })
})

$(document).ready(() => {
  $('.show-more-inspectors').on('click', function () {
    $(this).hide()
    $('.more-inspectors').slideDown()
  })

  // SHUA-4370 — collapsed company header on mobile.
  // The markup is emitted the same at every width and CSS decides whether the
  // collapsed layout applies, so this owns only the state class, its aria mirror,
  // and the toggle's label (the design shows "Details" collapsed / "Hide" expanded;
  // the caret is flipped in CSS).
  $('.company-header-details-toggle').on('click', function () {
    const expanded = $('.info-form--collapsible')
      .toggleClass('is-expanded')
      .hasClass('is-expanded')

    $(this)
      .attr('aria-expanded', expanded ? 'true' : 'false')
      .find('.company-header-details-toggle__label')
      .text(expanded ? 'Hide' : 'Details')
  })

  $('.company-header-inspectors-more').on('click', function () {
    $(this).hide()
    // slideDown finishes by writing an inline display:block, but the remainder
    // list is a flex row like the first three — restore it once the reveal ends.
    $('.company-header-inspectors-compact__rest').slideDown(200, function () {
      $(this).css('display', 'flex')
    })
  })
})
